import React, { useState } from 'react'
import { Button, Modal, Tab, Table, Tabs } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import format from 'date-fns/format'
import PropTypes from 'prop-types'

const RawDataModal = ({ show, onClose }) => {
  const [key, setKey] = useState('conditions')

  const { conditions, procedures, medications, observations } = useSelector((state) => ({
    conditions: state.patient.conditions,
    procedures: state.patient.procedures,
    medications: state.patient.medications,
    observations: state.patient.observations
  }))

  return (
    <Modal
      show={show}
      onHide={onClose}
      size='xl'
    >
      <Modal.Header closeButton>
        Patient Data pulled 
      </Modal.Header>
      <Modal.Body>
        <Tabs
          id='fhir-resource'
          activeKey={key}
          onSelect={(k) => setKey(k)}
        >
          <Tab eventKey='conditions' title='Conditions'>
            <Table className='font-85'>
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Code System</th>
                  <th>Clinical Status</th>
                  <th>Verification Status</th>
                  <th>Recorded Date</th>
                  <th>Onset Start Date</th>
                  <th>Onset End Date</th>
                </tr>
              </thead>
              <tbody>
                {
                  conditions.map((condition) => (
                    <tr key={`${condition.id}+${condition.code}`}>
                      <td>{condition.code}</td>
                      <td>{condition.name}</td>
                      <td>{condition.codeSystem}</td>
                      <td>{condition.clinicalStatus ? condition.clinicalStatus : ''}</td>
                      <td>{condition.verificationStatus ? condition.verificationStatus : ''}</td>
                      <td>{condition.recordedDate ? format(new Date(condition.recordedDate), 'yyyy-MM-dd') : ''}</td>
                      <td>{condition.onsetStartDate ? format(new Date(condition.onsetStartDate), 'yyyy-MM-dd') : ''}</td>
                      <td>{condition.onsetEndDate ? format(new Date(condition.onsetEndDate), 'yyyy-MM-dd') : ''}</td>
                    </tr>
                  ))
                }
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey='observations' title='Observations/Labs'>
            <Table className='font-85'>
              <thead>
                <tr>
                  <th>Effective Date</th>
                  <th>Issued Date</th>
                  <th>Code</th>
                  <th>Code Description</th>
                  <th>Value</th>
                  <th>Value Unit</th>
                  <th>Data Absent</th>
                </tr>
              </thead>
              <tbody>
                {
                  observations.map((observation) => {
                    return (
                      <tr key={`observation-${observation.patientObservationId}`}>
                        <td>{observation.effectiveDate ? format(new Date(observation.effectiveDate), 'yyyy-MM-dd') : ''}</td>
                        <td>{observation.issuedDate ? format(new Date(observation.issuedDate), 'yyyy-MM-dd') : ''}</td>
                        <td>{observation.code ? observation.code : ''}</td>
                        <td>{observation.codeDescription ? observation.codeDescription : ''}</td>
                        <td>{observation.value}</td>
                        <td>{observation.valueUnit}</td>
                        <td>{observation.dataAbsent === 1 ? 'YES' : 'NO'}</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey='procedures' title='Procedures'>
            <Table className='font-85'>
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Performed Date</th>
                </tr>
              </thead>
              <tbody>
                {
                  procedures && procedures.map((procedure) => (
                    <tr key={`procedure-${procedure.patientProcedureId}`}>
                      <td>{procedure.code}</td>
                      <td>{procedure.performedDate ? format(new Date(procedure.performedDate), 'yyyy-MM-dd') : null}</td>
                    </tr>
                  ))
                }
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey='medications' title='Medications'>
            <Table className='font-85'>
              <thead>
                <tr>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Frequency</th>
                  <th>Dispense Quantity Value</th>
                  <th>Dispense Quantity Unit</th>
                  <th>Recorded Date</th>
                  <th>Name</th>
                  <th>Code</th>
                </tr>
              </thead>
              <tbody>
                {
                  medications.map((medication) => {
                    return (
                      <tr key={`medication-${medication.patientMedicationId}`}>
                        <td>{ medication.startDate ? medication.startDate : ''}</td>
                        <td>{medication.endDate ? medication.endDate : ''}</td>
                        <td>{medication.frequency}</td>
                        <td>{medication.dispenseQuantityValue}</td>
                        <td>{medication.dispenseQuantityUnit}</td>
                        <td>{medication.supplyDuration}</td>
                        <td>{medication.name}</td>
                        <td>{medication.code}</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

RawDataModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func
}

export default RawDataModal